import { useState } from "react";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2400);
  };

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      showToast("链接已复制，去分享给一起吃瓜的朋友吧");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
    setOpen(false);
  };

  const options = [
    { label: "微信", icon: "ri-wechat-line", hint: "演示：微信分享仅为前端展示" },
    { label: "微博", icon: "ri-weibo-line", hint: "演示：微博分享仅为前端展示" },
    { label: "朋友圈", icon: "ri-contacts-line", hint: "演示：朋友圈分享仅为前端展示" },
  ];

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1.5 px-3.5 h-9 rounded-md bg-primary-500 text-background-50 text-[13px] font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
      >
        <i className="ri-share-forward-line" />
        分享
      </button>
      <button
        type="button"
        onClick={copyLink}
        className="inline-flex items-center gap-1.5 px-3.5 h-9 rounded-md border border-background-300 text-foreground-700 text-[13px] whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
      >
        <i className="ri-link" />
        复制链接
      </button>

      {open && (
        <div className="fixed inset-0 z-[60] flex items-end sm:items-center justify-center">
          <button
            type="button"
            aria-label="关闭分享弹窗"
            onClick={() => setOpen(false)}
            className="absolute inset-0 bg-primary-950/50 cursor-pointer animate-fadeIn"
          />
          <div className="relative w-full sm:w-[420px] bg-background-50 rounded-t-xl sm:rounded-lg p-5 animate-fadeUp">
            <div className="flex items-start justify-between gap-4 mb-1">
              <h3 className="font-heading text-base font-bold text-foreground-900">分享这条爆料</h3>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="w-8 h-8 rounded-full flex items-center justify-center text-foreground-500 hover:bg-background-100 cursor-pointer"
                aria-label="关闭"
              >
                <i className="ri-close-line" />
              </button>
            </div>
            <p className="text-[12.5px] text-foreground-500 line-clamp-1 mb-4">{title}</p>
            <div className="grid grid-cols-4 gap-2">
              {options.map((option) => (
                <button
                  key={option.label}
                  type="button"
                  onClick={() => {
                    showToast(option.hint);
                    setOpen(false);
                  }}
                  className="flex flex-col items-center gap-2 py-3 rounded-md bg-background-100 hover:bg-accent-50 transition-colors cursor-pointer"
                >
                  <i className={`${option.icon} text-xl text-primary-600`} />
                  <span className="text-[12px] text-foreground-700">{option.label}</span>
                </button>
              ))}
              <button
                type="button"
                onClick={copyLink}
                className="flex flex-col items-center gap-2 py-3 rounded-md bg-background-100 hover:bg-accent-50 transition-colors cursor-pointer"
              >
                <i className="ri-link text-xl text-primary-600" />
                <span className="text-[12px] text-foreground-700">复制链接</span>
              </button>
            </div>
            <p className="text-[11.5px] text-foreground-400 mt-4 leading-5">
              第三方分享暂为演示效果，未接入真实平台接口。
            </p>
          </div>
        </div>
      )}

      {toast && (
        <div className="fixed left-1/2 -translate-x-1/2 bottom-10 z-[70] px-4 py-2.5 rounded-md bg-primary-950 text-background-50 text-[13px] animate-fadeUp whitespace-nowrap">
          {toast}
        </div>
      )}
    </div>
  );
}